import {
  Navbar,
  FooterOverlay,
  SubHeading,
  ContactForm,
  GetInTouch,
  Social,
} from '../../components';

import { StyleSheet, css } from 'aphrodite';

const Contact = () => {
  return (
    <div className={css(styles.pageWrapper)}>
      <Navbar />

      <div className={css(styles.contactSection)}>
        <div className={css(styles.container)}>
          <SubHeading title="Enquiries" />

          <div className={css(styles.content)}>
            <ContactForm />
            <GetInTouch />
          </div>
        </div>
      </div>

      <div className={css(styles.mapSection)}>
        <iframe
          title="Fortress Restaurant Location"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d898.1342539758164!2d28.279448269647276!3d-25.785851791017514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDQ3JzA5LjEiUyAyOMKwMTYnNDguMyJF!5e0!3m2!1sen!2sza!4v1762948997119!5m2!1sen!2sza"
          className={css(styles.map)}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      <div className={css(styles.socialSection)}>
        <SubHeading title="Follow us on Social Media" />
        <Social />
      </div>

      <FooterOverlay />
    </div>
  );
};

const styles = StyleSheet.create({
  pageWrapper: {
    backgroundColor: 'var(--color-cream)',
    minHeight: '100vh',
  },
  contactSection: {
    paddingTop: '10rem',
    paddingBottom: '4rem',
    textAlign: 'center',
  },

  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 2rem',
  },

  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '3rem',
    marginTop: '3rem',
    flexWrap: 'wrap',

    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  mapSection: {
    padding: '2rem clamp(1.5rem,6vw,6rem) 5rem',
  },

  map: {
    width: '100%',
    height: '450px',
    border: 'none',
    borderRadius: '20px',
    boxShadow: 'var(--shadow-soft)',

    '@media (max-width: 768px)': {
      height: '300px',
    },
  },

  socialSection: {
    padding: '4rem 2rem',
    textAlign: 'center',
    background: 'var(--color-paper)',
  },
});

export default Contact;
